// Enhanced Template CSV v2.0 - Clean format with K-1 partnership data
// No metadata header - just columns and data rows
// Users can use any years (minimum 3 years, 4+ preferred)
export const ENHANCED_TEMPLATE_CSV = `# CLAIM METADATA
Business_Name,
Claimant_Name,
Street_Address,
City,
State,
Zip_Code,
Zone,
Business_Type,
EIN_Tax_ID,
Event_Type,
Event_Start_Date,
Event_End_Date,
FEMA_Declaration,
Contact_Email,
Contact_Phone,
Insurance_Company,
Policy_Number,

# BUSINESS DETAILS
Industry,
Employee_Count,
Annual_Revenue_Pre_Event,
Square_Footage,
Years_In_Business,
NAICS_Code,
Principal_Product,

# FORM 1065 & K-1 TAX DATA
Tax_Year,Partnership_Gross_Receipts,Partnership_COGS,Partnership_Salaries_Wages,Partnership_Other_Deductions,Partnership_Net_Ordinary_Income,Partner_A_Name,Partner_A_SSN,Partner_A_Ownership_%,Partner_A_Guaranteed_Payments,Partner_A_Ordinary_Income,Partner_A_Self_Employment_Income,Partner_B_Name,Partner_B_SSN,Partner_B_Ownership_%,Partner_B_Guaranteed_Payments,Partner_B_Ordinary_Income,Partner_B_Self_Employment_Income,Partnership_Depreciation,Partnership_Charitable_Contributions
2021,,,,,,,,,,,,,,,,,,,
2022,,,,,,,,,,,,,,,,,,,
2023,,,,,,,,,,,,,,,,,,,
2024,,,,,,,,,,,,,,,,,,,

# DOCUMENT CHECKLIST
Document,Status
Form 1065 (2021),
Form 1065 (2022),
Form 1065 (2023),
Form 1065 (2024),
Schedule K-1 Partner A (2021-2024),
Schedule K-1 Partner B (2021-2024),
P&L Statements,
Balance Sheets,

# MONTHLY FINANCIAL DATA
Month,Revenue,COGS,Officer_Salary_A,Officer_Salary_B,Employee_Wages,Payroll_Taxes,Employee_Benefits,Rent,Utilities,Marketing,Other_Expenses,K1_Partner_A_Dist,K1_Partner_B_Dist,Partner_A_Own_%,Partner_B_Own_%
Jan 2021,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Feb 2021,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Mar 2021,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Apr 2021,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
May 2021,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Jun 2021,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Jul 2021,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Aug 2021,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Sep 2021,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Oct 2021,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Nov 2021,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Dec 2021,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Jan 2022,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Feb 2022,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Mar 2022,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Apr 2022,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
May 2022,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Jun 2022,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Jul 2022,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Aug 2022,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Sep 2022,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Oct 2022,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Nov 2022,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Dec 2022,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Jan 2023,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Feb 2023,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Mar 2023,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Apr 2023,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
May 2023,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Jun 2023,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Jul 2023,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Aug 2023,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Sep 2023,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Oct 2023,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Nov 2023,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Dec 2023,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Jan 2024,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Feb 2024,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Mar 2024,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Apr 2024,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
May 2024,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Jun 2024,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Jul 2024,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Aug 2024,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Sep 2024,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Oct 2024,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Nov 2024,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50
Dec 2024,0,0,0,0,0,0,0,0,0,0,0,0,0,50,50`;

// Field guide URL for download
export const FIELD_GUIDE_URL = 'https://customer-assets.emergentagent.com/job_healthclaim-1/artifacts/t3q9i49t_Enhanced_Template_Field_Guide.md';

export const downloadTemplate = () => {
  const blob = new Blob([ENHANCED_TEMPLATE_CSV], { type: 'text/csv' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = 'Enhanced_Financial_Template_Blank.csv';
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};

export const downloadFieldGuide = () => {
  window.open(FIELD_GUIDE_URL, '_blank');
};
